import { ApiRequest } from "framework/api";
import { Integration } from "./integration";

export function getIntegrations() {
	return new ApiRequest<Integration[]>({
		url: 'management/extensions',
		method: 'GET'
	})
}
